import { useCallback } from 'react';
import { useToasts } from 'stateful-ui/src';
import { Attachment } from 'stateful-ui/src/generated/gql';
import { ConfigContext } from 'stateful-ui/src/providers/ConfigContext';
import { useFetch } from 'stateful-ui/src/hooks/useFetch';

export const useDeleteCommunityAttachment = () => {
  const { fetch, loading } = useFetch();
  const { pushToast } = useToasts();
  const config = ConfigContext.useContainer();

  const deleteFile = useCallback(
    async (attachment: Attachment) => {
      try {
        await fetch(
          `${config.aws.attachments.gateway}/community/attachments/${attachment.id}`,
          {
            method: 'DELETE',
          },
        );
      } catch {
        pushToast({
          variables: {
            toast: {
              message: `The file ${attachment.name} could not be deleted`,
            },
          },
        });
        throw new Error('deletion failed');
      }
    },
    [pushToast, config, fetch],
  );

  return { loading, deleteFile };
};
